import type { IStorageService } from '../../../types/lt/ltCommon.d.ts';

export default class StorageService implements IStorageService {
	public sessionGet<T>(key: string): string | T {
		let value: string | T = window.sessionStorage.getItem(key) as string;
		if (value) {
			value = JSON.parse(value) as T;
		}

		return value;
	}

	public sessionSet<T>(key: string, data: T): void {
		const value = JSON.stringify(data);
		window.sessionStorage.setItem(key, value);
	}

	public sessionRemove(key: string): void {
		window.sessionStorage.removeItem(key);
		if (window.sessionStorage.getItem(key)) {
			window.sessionStorage.setItem(key, '');
		}
	}
}

export const storageService = new StorageService();
